import React from 'react';

const CurvedShape = ({ fill }) => (
    <svg width='301' height='347' viewBox='0 0 301 347' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M0 346.002H301.001C127.228 319.849 21.2381 93.5263 0 0V346.002Z'
            fill={fill}
        />
    </svg>
);

export default CurvedShape;
